import { createApp } from "vue";
import App from "./App.vue";
import Chart from "chart.js/auto"
import { clickOutside } from '@/directives/clickOutside.js'

// CSS
import "leaflet/dist/leaflet.css"; // Leaflet map styles
import './assets/css/global.css'; // Global styles
import './assets/css/maps.css'; // Map-specific styles

const styles = getComputedStyle(document.documentElement)


// ChartJS global config -------
const chartFont = styles.getPropertyValue('--font-family') ||  "'proxima-nova', 'Proxima Nova', 'Helvetica Neue', 'Arial', sans-serif";
// console.log("Chart global font set to:", chartFont)

Chart.defaults.font.family = chartFont

// console.log("Chart default font:", Chart.defaults.font.family)
Chart.defaults.font.size = 13
// Chart.defaults.color = "#5b5b5b"

Object.assign(Chart.defaults.plugins.legend, {
  labels: {
    font: {
      family: chartFont,
      size: 12,
      weight: 500,
    },
  }, 
})

Object.assign(Chart.defaults.plugins.tooltip, {
  titleFont: {
    family: chartFont,
    size: 14,
    weight: 700,
  },
  bodyFont: {
    family: chartFont,
    size: 12,
  },
})

Chart.defaults.borderColor = "rgba(0,0,0,0.08)"
Chart.defaults.scale.grid.color = "rgba(0,0,0,0.08)"


// App instance -------
const app = createApp(App)
app.directive('click-outside', clickOutside)
app.mount("#app");
